import { StoreState } from "store/index";

export const getFlyAnywhere = (store: StoreState) => store.flyAnywhere;
export const getFlyAnywhereCountries = (store: StoreState) => store.flyAnywhere?.countries;
export const getFlyAnywhereDestination = (store: StoreState) => store.flyAnywhere?.destination;
export const getFlyAnywhereFromCityName = (store: StoreState) => store.flyAnywhere?.fromCity?.name;
